import React from "react";
import { formItems } from "../../../shared/informationRequest/informationRequestConfiguration";
import { formatPenceNumberString } from "../../../shared/utils/moneyUtils";
import RenderCompletedQuestion from "../utils/RenderCompletedQuestion";

const completedAnswer = (fieldType, fieldValue) => {
  if (fieldType === "date" || fieldType === "date_in_the_past" || fieldType === "must_happen_by_date") {
    let date;

    if (fieldValue.includes("/")) {
      // Old submission in dd/mm/yyyy format
      const parts = fieldValue.split("/");
      date = new Date(`${parts[2]}-${parts[1]}-${parts[0]}`);
    } else {
      date = new Date(fieldValue);
    }

    return {
      day: date.getDate().toString(),
      month: (date.getMonth() + 1).toString(), // getMonth returns 0-indexed number
      year: date.getFullYear().toString(),
    };
  } else if (fieldType === "confirmation") {
    return true;
  } else if (fieldType === "money") {
    // The stored answer is pence. The live form reverses it with
    // parseExistingValue, and this view must show the same pounds. An
    // optional field the client left blank is stored as "", which has no
    // pounds to show.
    return fieldValue ? formatPenceNumberString(fieldValue) : fieldValue;
  }
  return fieldValue;
};

const fieldConfig = (doable, identifier) =>
  doable.configuration?.fields?.find((f) => f.field_identifier === identifier);

// The submitted answers, keyed by field, in the shapes the completed questions render
export const completedResponses = (doable) => {
  const submission = doable.submission;
  const responses = {};
  if (!submission) {
    return responses;
  }

  // A step of documents alone submits no fields, and the server marshals the
  // submission with omitempty, so the stored snapshot has no fields key.
  (submission.fields ?? []).forEach((field) => {
    const fieldId = field.fieldName;
    const config = fieldConfig(doable, fieldId);
    const fieldType = config?.field_type ?? null;

    if (fieldType === "checkbox") {
      responses[fieldId] = {};
      (config.choices ?? []).forEach((choice) => (responses[fieldId][choice.value] = false));

      (field.fieldValues ?? []).forEach((value) => (responses[fieldId][value] = true));
    }

    if (field.fieldValue !== null) {
      responses[fieldId] = completedAnswer(fieldType, field.fieldValue);
    }
  });

  return responses;
};

const uploadsForDocument = (doable, identifier) =>
  (doable.submission?.uploaded_documents ?? []).filter((document) => document.identifier === identifier);

const CompletedAnswers = ({ doable, responses }) => {
  const configuration = doable.configuration;
  const { fieldsByIdentifier, itemIdentifiers } = formItems(configuration);

  return itemIdentifiers.map((name) => {
    return (
      <RenderCompletedQuestion
        key={name}
        doableConfig={configuration}
        fieldConfig={fieldsByIdentifier.get(name)}
        responses={responses}
        selected={responses[name] || false}
        value={responses[name] || ""}
        uploads={uploadsForDocument(doable, name)}
        disabled={true}
      />
    );
  });
};

export default CompletedAnswers;
